import { getApi, postApi } from 'apis';

const verifyEmployeeSSN = async (data: any) => {
	return await postApi(`/integration/napsa/member-kyc`, data);
};

const verifyEmployeeNRC = async (data: any) => {
	return await postApi(`/integration/napsa/member-by-nrc`, data);
};
const getNapsaRecords = async (data: any) => {
	return await postApi('/calculation/napsa/records', data);
};
const submitNapsaReturn = async (data: any) => {
	return await postApi('/calculation/napsa/submit', data);
};

const checkReturnStatus = async (data: any) => {
	return await postApi('/calculation/napsa/status', data);
};

const getNapsaReturnLogs = async (data: any) => {
	return await getApi('/calculation/napsa/returnLogs', data);
};

const getCeilingValue = async (data: any) => {
	return await postApi(`/integration/napsa/ceilingValue`, data);
}

export const napsaIntegrationServiceApi = {
	verifyEmployeeNRC,
	verifyEmployeeSSN,
	getNapsaRecords,
	checkReturnStatus,
	submitNapsaReturn,
	getNapsaReturnLogs,
	getCeilingValue
};
